/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { string, bool } from 'prop-types';

import { INTERCOM_REQUEST_OFFER_CLASS } from 'ggApp/modules/intercom';
import { Translator } from 'ggApp/modules/translator/components';
import { mixLinkOnNavEnabled as mixLinkOnNavEnabledSelector } from 'ggApp/modules/featureFlag/selectors';

import { Wrap, Link, Button, IntercomTrigger } from './styled';

const PageLinks = ({
    className,
    isDesktopUser,
    isTransparent,
    isLoggedIn,
    countryCode,
    storeCode,
    activeLanguage,
    isBusinessStore,
    isPartner,
    businessStoreDealsEnabled,
    requestOfferEnabled,
    mixLinkOnNavEnabled,
}) => {
    let hiwCode = storeCode;
    let external = false;

    if (isPartner) {
        hiwCode = countryCode;
        external = true;
    }

    const storeLink = useCallback(() => {
        if (isLoggedIn || !isDesktopUser || countryCode !== 'de') {
            return null;
        }

        const sLink = isBusinessStore
            ? `/de-${activeLanguage}`
            : `/business-${activeLanguage}/for-business`;

        return (
            <Link
                external
                pageLinkTo={sLink}
                pageLinkTk={
                    isBusinessStore ? 'OFFERINGS_LINKS_B2C_TEXT' : 'OFFERINGS_LINKS_B2B_TEXT'
                }
                type="countrySpecificLink"
            />
        );
    }, [isLoggedIn, isDesktopUser, countryCode, activeLanguage, isBusinessStore]);

    const businessLink = useCallback(() => {
        if (isLoggedIn || !isDesktopUser || (countryCode !== 'nl' && countryCode !== 'at')) {
            return null;
        }
        return (
            <IntercomTrigger id="open-lead-bot">
                <Translator
                    tk={isBusinessStore ? 'OFFERINGS_LINKS_B2C_TEXT' : 'OFFERINGS_LINKS_B2B_TEXT'}
                />
            </IntercomTrigger>
        );
    }, [isLoggedIn, isDesktopUser, countryCode, isBusinessStore]);

    return (
        <Wrap className={className} isTransparent={isTransparent}>
            {(isDesktopUser || !isLoggedIn) && !storeCode.startsWith('business_') && (
                <Link
                    pageLinkTo={`/${hiwCode}-${activeLanguage}/how-it-works`}
                    pageLinkTk="TIPS_LINKS_HIW_TEXT"
                    external={external}
                    type="countrySpecificLink"
                />
            )}

            {(isDesktopUser || isLoggedIn) && !storeCode.startsWith('business_') && (
                <Link pageLinkTo="/trending" pageLinkTk="OFFERINGS_LINKS_TOP_PRODUCTS_TEXT" />
            )}

            {isDesktopUser &&
                (!isBusinessStore || businessStoreDealsEnabled) &&
                !storeCode.startsWith('business_') &&
                storeCode !== 'us' && (
                    <Link pageLinkTo="/deals" pageLinkTk="OFFERINGS_LINKS_DEALS_TEXT" />
                )}

            {mixLinkOnNavEnabled && isDesktopUser && !isBusinessStore && storeCode === 'de' && (
                <Link pageLinkTo="/mix" pageLinkTk="MIX_LANDING_NAV_TITLE" />
            )}

            {isDesktopUser && requestOfferEnabled && (
                <Button className={INTERCOM_REQUEST_OFFER_CLASS} type="button">
                    <Translator tk="OFFERINGS_LINKS_REQUEST_OFFER_TEXT" />
                </Button>
            )}

            {storeLink()}
            {businessLink()}
        </Wrap>
    );
};

PageLinks.propTypes = {
    className: string,
    isDesktopUser: bool,
    isLoggedIn: bool,
    countryCode: string,
    storeCode: string,
    activeLanguage: string,
    isBusinessStore: bool,
    isPartner: bool,
    businessStoreDealsEnabled: bool,
    requestOfferEnabled: bool,
    mixLinkOnNavEnabled: bool,
};

PageLinks.defaultProps = {
    className: '',
    isDesktopUser: false,
    isLoggedIn: false,
    countryCode: '',
    storeCode: '',
    activeLanguage: '',
    isBusinessStore: false,
    isPartner: false,
    requestOfferEnabled: false,
    businessStoreDealsEnabled: false,
    mixLinkOnNavEnabled: false,
};

const enhance = connect(
    createStructuredSelector({
        mixLinkOnNavEnabled: mixLinkOnNavEnabledSelector,
    }),
);

export default enhance(PageLinks);
